import React from 'react'
import ModernAlert from '../alert/ModernAlert'
import './custom-dunut.css'
import Dunut from './Dunut'

const CustomDunut = props => {
    const valueSec = props.data.listData[1].value.replace(',', '.')
    const valueMec = props.data.listData[0].value.replace(',', '.')
    const valueCon = props.data.listData[2].value.replace(',', '.')
    const data = [
        { label: props.data.listData[1].label, value: parseFloat(valueSec), color: props.data.listData[1].color.hexa },
        { label: props.data.listData[0].label, value: parseFloat(valueMec), color: props.data.listData[0].color.hexa === '#ffff00' ? 'orange' : props.data.listData[0].color.hexa },
        { label: props.data.listData[2].label, value: parseFloat(valueCon), color: props.data.listData[2].color.hexa },
    ]
 

    console.log(props.data)

    let renderGraph = true
    if (isNaN(data[0].value) || isNaN(data[1].value) || isNaN(data[2].value)) {
        renderGraph = false
    }

    return (
        <div className='custom-dunut-container'>
            {renderGraph ? (
                <>
                    <span className='custom-dunut-title'>{props.data.label}</span>

                    <div className='dunut-container'>
                        <Dunut data={data} />
                    </div>
                    <div className='custom-dunut-legend-container' style={{ width: '90%' }}>
                        {data.map((d, i) => {
                            return (
                                <div className='legend-iten-dunut' key={i}>
                                    <div className='legend-box'
                                        style={{ backgroundColor: d.color }}
                                    />
                                    {/* <span className='legend-title'>{`${d.value}% ${d.label}`}</span> */}
                                    <span className='legend-title'>{`${d.label}`}</span>
                                </div>

                            )
                        })}


                    </div>
                </>
            ) : (
                <>
                <div style={{width: '95%'}}>
                <ModernAlert msg='Não foi possível renderizar o gráfico' color={''}/>

                </div>
                </>
            )}

        </div>
    )
}

export default CustomDunut